import type { Page } from '@shared/types/Tilelist';

export function canonicalPage(page: Page): Page {
    return {
        ...(page.l && page.o !== '0' && { l: page.l }),
        ...(page.o && page.o !== '0' && { o: page.o }),
        ...(page.sortiertnach && page.sortiertnach !== 'topseller' && { sortiertnach: page.sortiertnach }),
        ...(page.c && { c: page.c }),
    };
}
